import { ZoneCalculatorProvider } from './InputsContext'
import { CalculatorForm } from './CalculatorForm'

const INITIAL_SERVICE = 'pickUpPointDelivery'

export const ZoneCalculator = ({ labels, priceEngineProxyUrl }) => (
    <ZoneCalculatorProvider initialService={ INITIAL_SERVICE }>
        <CalculatorForm {...{
            priceEngineProxyUrl,
            labels
        }} />
    </ZoneCalculatorProvider>
)
